document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('[data-aos]:not(.data-aos-animate)');
  let observer;

  function initObserver() {
    observer = new IntersectionObserver(
      (entries) => {
        const animateElements = [];
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            animateElements.push(entry.target);
          }
        });
        if (animateElements.length) {
          requestAnimationFrame(() => {
            animateElements.forEach(el => {
              const duration = el.dataset.aosDuration || 1000;
              const delay = el.dataset.aosDelay || 0;
              const once = el.dataset.aosOnce === 'true';

              el.style.transitionDuration = `${duration}ms`;
              if (delay) el.style.transitionDelay = `${delay}ms`;
              el.classList.add('data-aos-animate');

              if (once) {
                observer.unobserve(el);
              }
            });
          });
        }
      },
      {
        threshold: 0.25, // Increased for better mobile performance
        rootMargin: '10px' // Reduced to minimize pre-loading
      }
    );

    elements.forEach(el => observer.observe(el));
  }

  if (elements.length) {
    initObserver();
  }
});